import { z } from 'zod'

import { baseInstrumentSchema } from '@/pages/instruments/new-instrument/schemas/shared/base.schema'

export const fxfwdSchema = baseInstrumentSchema.extend({
  instrument_type: z.literal('fxfwd'),
  fund_id: z.number().int(),
  top_level_bucket_id: z.number().int().nullable(),
  currency_from_id: z.number().int(),
  currency_quote_id: z.number().int(),
  counterparty_id: z.number().int(),
  structure_name: z.string().nonempty(),
  maturity_date: z.iso.date(),
  description: z.string().optional(),
})

export type FxFwdSchemaType = z.infer<typeof fxfwdSchema>
